module.exports = {
  SelectReconciliationRules: 'เลือกกฎการตรวจสอบ',
  ReturnToReconciliationNewVersion: 'กลับไปที่เวอร์ชันใหม่ของการตรวจสอบ',
  StartReconciliation: 'เริ่มการตรวจสอบ',
  Save: 'บันทึก',
  ManualReconciliation: 'ตรวจสอบด้วยมือ',
  CancelManualReconciliation: 'ยกเลิกการตรวจสอบด้วยมือ',
  ShowAllReconciliationCost: 'แสดงค่าบริการทั้งหมดที่ตรวจสอบ',
  ShowConsistentReconciliationCost: 'แสดงค่าบริการที่ตรงกันในการตรวจสอบ',
  ShowPartiallyConsistentReconciliationFees: 'แสดงค่าบริการที่ตรงกันบางส่วนในการตรวจสอบ',
  ShowUnmatchedCosts: 'แสดงค่าบริการที่ยังไม่ตรงกัน',
  Note: 'คำอธิบาย:',
  Green: 'สีเขียว',
  IndicatesConsistentReconciliationResults: 'หมายถึงผลการตรวจสอบตรงกัน',
  Black: 'สีดำ',
  IndicatesNoCorrespondingChargeFound: 'หมายถึงไม่พบค่าบริการที่ตรงกัน',
  Red: 'สีแดง',
  IndicatesInconsistentAmounts: 'หมายถึงจำนวนเงินไม่ตรงกัน',
  Orange: 'สีส้ม',
  IndicatesManualReconciliationComplete: 'หมายถึงการตรวจสอบด้วยมือเสร็จสิ้น',
  IfEtcPleaseGoModule: 'หากต้องการจัดการส่วนต่าง กรุณาไปที่โมดูลเวอร์ชันใหม่ของการตรวจสอบ',
  ImportExternalCharges: 'นำเข้าค่าบริการจากภายนอก',
  InternalSystemCharges: 'ค่าบริการภายในระบบ',
  IfMaintainReconciliationRulesClick: 'หากต้องการบำรุงรักษากฎการตรวจสอบ กรุณาคลิก',
  ReconciliationRuleEngineConfiguration: 'การตั้งค่าเครื่องมือกฎการตรวจสอบ',
  ReconciliationConsistent: 'ตรวจสอบตรงกัน',
  Items: 'รายการ',
  InconsistentAmounts: 'จำนวนเงินไม่ตรงกัน',
  CorrespondingChargesNotFound: 'ไม่พบค่าบริการที่ตรงกัน',
  ImportSucceeded: 'นำเข้าเสร็จสิ้น',
  CancelAllManualReconciliations: 'ยกเลิกการตรวจสอบด้วยมือทั้งหมด',
  ExportAllComparisonResults: 'ส่งออกผลการเปรียบเทียบทั้งหมด',
  ExportConsistentComparisonResults: 'ส่งออกผลการเปรียบเทียบที่ตรงกัน',
  ExportDiscrepancyComparisonResults: 'ส่งออกผลการเปรียบเทียบที่แตกต่าง',
  BusinessNumber: 'เลขที่ธุรกิจ',
  ShipName: 'ชื่อเรือ',
  VoyageNumber: 'เที่ยวเรือ',
  ContainerNumber: 'เลขตู้',
  ConfirmationStatus: 'สถานะการยืนยัน',
  ChargeName: 'ชื่อค่าบริการ',
  Currency: 'สกุลเงิน',
  PriceIncludingTax: 'ราคารวมภาษี',
  PriceExcludingTax: 'ราคาไม่รวมภาษี',
  TaxRate: 'อัตราภาษี',
  TaxAmount: 'จำนวนภาษี',
  Difference: 'ส่วนต่าง',
  ReconciliationAmount: 'จำนวนเงินที่ตรวจสอบ',
  UnitPrice: 'ราคาต่อหน่วย',
  Quantity: 'จำนวน',
  InvoiceNumber: 'เลขที่ใบแจ้งหนี้',
  ReconciliationResult: 'ผลการตรวจสอบ',
  ReconciliationRuleName: 'ชื่อกฎการตรวจสอบ',
  ComparisonOrder: 'ลำดับการเปรียบเทียบ',
  PleaseNeedToBeReconciliation: 'กรุณาเลือกค่าใช้จ่ายที่ต้องการตรวจสอบก่อนทำการตรวจสอบด้วยตนเอง',
  ManualReconciliationSucceeded: 'ตรวจสอบด้วยตนเองสำเร็จ',
  AreCancelAllManualTime: 'ยืนยันที่จะยกเลิกข้อมูลการตรวจสอบด้วยตนเองทั้งหมดครั้งนี้หรือไม่?',
  Tips: 'แจ้งเตือน',
  Yes: 'ใช่',
  No: 'ไม่',
  CancelAllManualReconciliationsSuccessful: 'ยกเลิกการตรวจสอบด้วยตนเองทั้งหมดสำเร็จ',
  RequestSucceededExporting: 'คำขอสำเร็จ กำลังส่งออก!',
  SavedSuccessfully: 'บันทึกสำเร็จ',
  PleaseUseAndFillNumbers: 'กรุณาเลือกกฎการตรวจสอบที่ต้องการใช้ และกรอกลำดับการเปรียบเทียบด้วยตัวเลข',
  Unconfirmed: 'ยังไม่ยืนยัน',
  Confirmed: 'ยืนยันแล้ว',
  ViewDetails: 'ดูรายละเอียด',
  Return: 'กลับ',
  ShowAllReconciliationFees: 'แสดงค่าใช้จ่ายทั้งหมดที่ตรวจสอบ',
  ShowFullyReconciledFees: 'แสดงค่าใช้จ่ายที่ตรงกัน',
  ShowPartiallyReconciledFees: 'แสดงค่าใช้จ่ายที่ตรงกันบางส่วน',
  ShowUnmatchedFees: 'แสดงค่าใช้จ่ายที่ไม่ตรงกัน',
  IndicatesReconciliationResultIsConsistent: 'หมายถึงผลการตรวจสอบตรงกัน',
  IndicatesCorrespondingFeeNotFound: 'หมายถึงไม่พบค่าใช้จ่ายที่ตรงกัน',
  IndicatesAmountInconsistency: 'หมายถึงจำนวนเงินไม่ตรงกัน',
  IndicatesManualReconciliationCompleted: 'หมายถึงการตรวจสอบด้วยตนเองเสร็จสิ้น',
  ImportExternalFees: 'นำเข้าค่าใช้จ่ายภายนอก',
  SystemInternalFees: 'ค่าใช้จ่ายภายในระบบ',
  ViewFile: 'ดูไฟล์',
  System: 'ระบบ',
  Voyage: 'เที่ยวบิน',
  FeeName: 'ชื่อค่าใช้จ่าย',
  TaxIncludedPrice: 'ราคารวมภาษี',
  TaxExcludedPrice: 'ราคาไม่รวมภาษี',
  PleaseSelectOneRecord: 'กรุณาเลือกหนึ่งรายการ',
  All: 'ทั้งหมด',
  BankName: 'ชื่อธนาคาร',
  YouPermissionToViewData: 'คุณไม่มีสิทธิ์ดูข้อมูลนี้',
  QuickRetrieval: 'ค้นหาด่วน:',
  Selected: 'เลือก',
  QuickRetrievalBillNumber: 'ค้นหาด่วน:หมายเลขบิล',
  BillClaims: 'การรับรองใบเสร็จ',
  FinancialReview: 'การตรวจสอบทางการเงิน',
  QuickRetrievalBusinessNumber: 'ค้นหาด่วน:หมายเลขธุรกิจ',
  QuickRetrievalWaterBillNumber: 'ค้นหาด่วน:หมายเลขใบเสร็จ',
  WaterBillClaims: 'การรับรองใบเสร็จ',
  Unused: 'ยังไม่ใช้',
  PleaseAWaterBillRecord: 'กรุณาเลือกรายการใบเสร็จ',
  WaterReleasedAndCannotModified: 'ใบเสร็จถูกเผยแพร่แล้ว ไม่สามารถแก้ไขได้',
  WaterClaimedAndCannotModified: 'ใบเสร็จถูกรับรองแล้ว ไม่สามารถแก้ไขได้',
  WaterReturnedAndCannotModified: 'ใบเสร็จถูกส่งคืนแล้ว ไม่สามารถแก้ไขได้',
  WaterRecordsAndCannotVoided: 'ใบเสร็จมีบันทึกการตัดจ่ายแล้ว ไม่สามารถยกเลิกได้',
  WaterToFinancialVoucherVoided: 'ใบรับน้ำได้ส่งออกเอกสารทางการเงินแล้ว ไม่สามารถยกเลิกได้',
  Confirm: 'ยืนยัน',
  Cancel: 'ยกเลิก',
  NoBillRecordsToRelease: 'ไม่มีรายการใบรับน้ำที่จะเผยแพร่',
  NoRecordsToCancelRelease: 'ไม่มีรายการใบรับน้ำที่จะยกเลิกการเผยแพร่',
  OnlyCanRevokeTheBill: 'เฉพาะผู้ทำการตัดจ่ายเท่านั้นที่สามารถยกเลิกใบรับน้ำได้',
  WaterCannotBeRevokedFirst: 'ใบรับน้ำที่ได้รับการตรวจสอบแล้วไม่สามารถยกเลิกได้ กรุณายกเลิกการตรวจสอบก่อน',
  ThisPleaseDeleteTheAgain: 'ใบรับน้ำนี้ได้สร้างเอกสารทางการเงินแล้ว กรุณาลบเอกสารก่อนแล้วจึงยกเลิกอีกครั้ง',
  WaterBillRevocationSuccessful: 'ยกเลิกใบรับน้ำสำเร็จ',
  WaterBillRegistration: 'การลงทะเบียนใบรับน้ำ',
  WaterBillNotSelected: 'ยังไม่ได้เลือกใบรับน้ำ',
  AdvanceNoAdvancePaymentGenerated: 'ได้ทำการรับรู้เงินล่วงหน้าแล้ว แต่ยังไม่ได้สร้างเอกสารรับเงินล่วงหน้า',
  Claimed: 'รับรู้แล้ว',
  ReceivableClaimCompleted: 'ได้ทำการรับรู้ลูกหนี้แล้ว',
  PrepaymentClaimCompleted: 'ได้ทำการรับรู้เงินล่วงหน้าแล้ว',
  NoInTheCurrentBill: 'ใบรับน้ำปัจจุบันไม่มีจำนวนเงินรับรู้ที่เหลือ',
  PleaseDataToBeClaimed: 'กรุณาเลือกข้อมูลที่จะรับรู้',
  DomesticBill: 'บิลภายในประเทศ',
  InvoicingMetForReconciliationStatus: 'สถานะใบแจ้งหนี้ไม่ตรงตามข้อกำหนดในการออกใบกำกับภาษี!',
  AddToBillQueryList: 'เพิ่มลงในรายการค้นหาบิล',
  ForeignBill: 'บิลต่างประเทศ',
  AgencyCommissionBill: 'บิลแบ่งส่วนตัวแทน',
  Bill: 'บิล:',
  CreatePaymentRequestSelectFee: 'สร้างคำขอการชำระเงิน-เลือกค่าใช้จ่าย',
  SettlementTheBillCannotEmpty: 'ตัวแทนชำระบิลไม่สามารถเว้นว่างได้!',
  CreatePaymentRequestDetailedInformation: 'สร้างคำขอการชำระเงิน-รายละเอียด',
  ReconciliationBill: 'ใบแจ้งหนี้',
  QuickRetrievalReconciliationBillNumber: 'ค้นหาด่วน:เลขที่ใบแจ้งหนี้',
  Payable: '(เจ้าหนี้)',
  Receivable: '(ลูกหนี้)',
  ReconciliationByFee: 'การตรวจสอบบัญชี-ตามค่าใช้จ่าย',
  ReconciliationByBusiness: 'การตรวจสอบบัญชี-ตามธุรกิจ',
  SelectImportTemplateSolution: 'เลือกแผนแม่แบบการนำเข้า',
  Prompt: 'แจ้งเตือน',
  TemplateSolutionName: 'ชื่อแผนแม่แบบ',
  ToMaintainImportTemplatesClick: 'หากต้องการบำรุงรักษาแม่แบบการนำเข้า กรุณาคลิก',
  BasicDataImportTemplateSolutions: 'ข้อมูลพื้นฐาน-แผนแม่แบบการนำเข้า',
  PleaseSelectASolution: 'กรุณาเลือกแผน',
  PleaseSettlementUnitBeforeImporting: 'กรุณาค้นหาหน่วยชำระเงินก่อนนำเข้า',
  NoFoundNoNeedReconcile: 'ไม่พบค่าใช้จ่ายที่เกี่ยวข้อง ไม่จำเป็นต้องตรวจสอบบัญชี',
  PleaseBasicDataImportSolution: 'กรุณาไปที่ข้อมูลพื้นฐานเพื่อบำรุงรักษาแผนแม่แบบการนำเข้า',
  ImportErrorPleaseReImport: 'รูปแบบการนำเข้าผิดพลาด กรุณานำเข้าใหม่',
  PleaseSelectATemplate: 'กรุณาเลือกแม่แบบ',
  YouHavePermissionToOpen: 'คุณไม่มีสิทธิ์เปิด',
  Module: 'สิทธิ์ของโมดูล',
  ViewPaymentRequestForm: 'ดูแบบฟอร์มคำขอการชำระเงิน',
  CreatingFormFailedPleaseAgain: 'การสร้างแบบฟอร์มคำขอการชำระเงินล้มเหลว กรุณาบันทึกใหม่!',
  ShanghaiAirFreightPayment: 'การชำระเงินขนส่งทางอากาศเซี่ยงไฮ้',
  PaymentRequestDirect: 'คำขอการชำระเงินโดยตรง',
  IncludesReSelectPaymentNumber: 'มีค่าใช้จ่ายที่ออกใบกำกับภาษีแล้ว กรุณาเลือกใหม่! เลขที่แบบฟอร์มคำขอการชำระเงิน:',
  CantDirectlyChangeConfigurationAgain: 'ไม่สามารถตรวจสอบทางการเงินโดยตรงได้ โปรดเปลี่ยนการตั้งค่าแล้วลองอีกครั้ง!',
  Invoicing: 'ออกใบแจ้งหนี้',
  QueryMethod: 'วิธีการค้นหา',
  ByFee: 'ตามค่าใช้จ่าย',
  ByBusiness: 'ตามธุรกิจ',
  IncludeReceivables: 'รวมถึงลูกหนี้',
  NoteFilteredOutFullyBusiness: 'หมายเหตุ: หน้านี้ได้กรองธุรกรรมค่าใช้จ่ายที่หักลบหมดแล้ว',
  ConvertedToRMB: 'เท่ากับ RMB:',
  NextStep: 'ขั้นตอนต่อไป',
  NotFound: 'ไม่พบ',
  CorrespondingPrintTemplate: 'เทมเพลตการพิมพ์ที่เกี่ยวข้อง',
  WarehouseEntryNumber: 'หมายเลขเข้าโกดัง',
  BookingNumber: 'หมายเลขการจอง',
  CutOffDate: 'วันที่ปิดรับเอกสาร',
  ProjectNumber: 'หมายเลขโครงการ',
  OverseasCustomerService: 'บริการลูกค้าต่างประเทศ',
  PaymentApplicationNumber: 'หมายเลขคำร้องขอชำระเงิน',
  BillNumber: 'หมายเลขบิล',
  SettlementObject: 'วัตถุการชำระเงิน',
  PickUpType: 'ประเภทการรับสินค้า',
  MasterBillNumber: 'หมายเลขเอกสารหลัก',
  HouseBillNumber: 'หมายเลขเอกสารย่อย',
  EntrustingUnit: 'หน่วยผู้ว่าจ้าง',
  BusinessType: 'ประเภทธุรกิจ',
  BusinessDate: 'วันที่ทำธุรกรรม',
  VesselVoyage: 'ชื่อเรือและเที่ยวบิน',
  DeparturePort: 'ท่าเรือต้นทาง',
  DestinationPort: 'ท่าเรือปลายทาง',
  StartingStation: 'สถานีต้นทาง',
  TerminusStation: 'สถานีปลายทาง',
  TransitStation: 'สถานีผ่านแดน',
  DestinationPortAgent: 'ตัวแทนท่าเรือปลายทาง',
  Sales: 'ฝ่ายขาย',
  Operation: 'ฝ่ายปฏิบัติการ',
  CustomerService: 'ฝ่ายบริการลูกค้า',
  Documentation: 'เอกสาร',
  BusinessReferenceNumber: 'หมายเลขอ้างอิงธุรกรรม',
  CustomBusinessType: 'ประเภทธุรกิจที่กำหนดเอง',
  Accrued: 'ได้บันทึกแล้ว',
  FinancialDate: 'วันที่ทางการเงิน',
  DomesticForeign: 'ในประเทศ/ต่างประเทศ',
  IncomeAndExpensesType: 'ประเภทรายรับรายจ่าย',
  ExpenseStatus: 'สถานะค่าใช้จ่าย',
  Auditor: 'ผู้ตรวจสอบ',
  ExpenseName: 'ชื่อค่าใช้จ่าย',
  Unit: 'หน่วย',
  WriteOffAmount: 'จำนวนเงินที่หักลบ',
  UnwrittenOffAmount: 'จำนวนเงินที่ยังไม่ได้หักลบ',
  ContactPerson: 'ผู้ติดต่อ',
  Creator: 'ผู้สร้าง',
  CreationDate: 'วันที่สร้าง',
  Remark: 'หมายเหตุ',
  CorrelationNumber: 'เลขที่อ้างอิงการติดต่อ',
  DelegationCorrelationNumber: 'เลขที่อ้างอิงการมอบหมาย',
  Carrier: 'ผู้ขนส่ง',
  ConfirmationDate: 'วันที่ยืนยัน',
  ExpenseConfirmer: 'ผู้ยืนยันค่าใช้จ่าย',
  RouteResponsiblePerson: 'ผู้รับผิดชอบเส้นทาง',
  BillingDate: 'วันที่ออกใบแจ้งหนี้',
  BillingHeader: 'ชื่อในใบแจ้งหนี้',
  NeedForInvoicing: 'ต้องการออกใบแจ้งหนี้หรือไม่',
  ConfirmationRemark: 'หมายเหตุการยืนยัน',
  AccountingDate: 'วันที่ตัดจ่าย',
  BusinessStatus: 'สถานะธุรกิจ',
  CustomField1: 'ฟิลด์กำหนดเอง 1',
  CustomField2: 'ฟิลด์กำหนดเอง 2',
  CustomField3: 'ฟิลด์กำหนดเอง 3',
  ReceiptAndPaymentDate: 'วันที่รับ/จ่าย',
  SalesDepartment: 'แผนกขาย',
  ChooseExpense: 'เลือกค่าใช้จ่าย',
  CreatePaymentApplicationChooseExpense: 'สร้างคำขอชำระเงิน-เลือกค่าใช้จ่าย',
  Other: 'อื่นๆ',
  YouViewOrPrintOthers: 'คุณไม่มีสิทธิ์ดูไฟล์ที่อัปโหลดหรือพิมพ์โดยผู้อื่น',
  BookingAgent: 'ตัวแทนการจอง',
  PleaseSelect: 'กรุณาเลือกสิ่งที่ต้องการ',
  ProvisionalBusinesses: 'ธุรกิจที่จัดสรร',
  ChangeOrderApprovalSuccess: 'ตรวจสอบการแก้ไขสำเร็จ',
  ThisIsNotForProvision: 'ธุรกิจนี้ไม่ใช่ธุรกิจที่รอจัดสรร ไม่สามารถจัดสรรได้!',
  ForPleaseChooseProvisionedBusiness: 'ยังไม่ได้จัดสรร กรุณาเลือกธุรกิจที่จัดสรรแล้ว!',
  FrontendErrorCallbackFailed: 'ข้อผิดพลาดส่วนหน้า: การเรียกกลับล้มเหลว',
  RouteManager: 'ผู้รับผิดชอบเส้นทาง',
  ThisFieldCannotBeEmpty: 'ห้ามเว้นว่างรายการนี้',
  OperationAllowedToBeEmpty: 'การดำเนินการห้ามเว้นว่าง',
  OperatingAllowedToBeEmpty2: 'แผนกดำเนินการห้ามเว้นว่าง',
  OperatingAllowedToBeEmpty3: 'สาขาดำเนินการห้ามเว้นว่าง',
  DesignatedFreightForwarder: 'ตัวแทนสินค้าที่กำหนด',
  OriginPortAgent: 'ตัวแทนท่าเรือต้นทาง',
  TransportationCompany: 'บริษัทขนส่ง',
  Warehouse: 'คลังสินค้า',
  CustomsBroker: 'บริษัทศุลกากร',
  CustomsDeclaration: 'ต้องดำเนินการศุลกากรหรือไม่',
  PickingStorage: 'การบรรจุภัณฑ์ภายใน/การจัดเก็บ',
  Storage: 'ต้องจัดเก็บหรือไม่',
  CargoType: 'ประเภทการรับสินค้า',
  ActualBillingWeight: 'น้ำหนักคิดค่าบริการจริง',
  QuotationNature: 'ลักษณะราคาตกลง',
  BookingType: 'ลักษณะการจอง',
  AllWriteOffs: 'ยกเลิกทั้งหมด',
  BusinessCannotBeEmpty: 'ธุรกิจห้ามเว้นว่าง!',
  ReviewSuccess: 'ตรวจสอบสำเร็จ',
  ReviewFailed: 'การตรวจสอบล้มเหลว',
  ColumnDataConversionRendering: 'การแปลงและการแสดงผลข้อมูลรายการ:',
  SelectActualReceiptAndPayment: 'เลือกรับจริงจ่ายจริง',
  SingleWriteOffDetailXls: 'รายละเอียดการตัดจ่ายรายปากกา.xls',
  SentOut: 'ส่งออกแล้ว!',
  FetchDate: 'วันที่เรียกคืน',
  ReturnDate: 'วันที่คืน',
  DeclarationDate: 'วันที่ประกาศ',
  SailingDate: 'วันที่ออกเรือ',
  OperationDate: 'วันที่ดำเนินการ',
  Contracted: 'ลงนามแล้ว',
  ContractExpired: 'สัญญาความล้มเหลว',
  Uncontracted: 'ยังไม่ลงนาม',
  ViewReturnOrderFiles: 'ดูไฟล์การคืน',
  OnlyWithTheSameStatus: 'สามารถพิมพ์เอกสารที่มีสถานะเดียวกันเท่านั้น',
  HouseWaybillNumber: 'หมายเลขแยกแผ่น',
  RevokeFetch: 'ยกเลิกการเรียกคืน',
  SentOutDate: 'วันที่ส่งออก',
  ProvisionedBusiness: 'ธุรกิจบริการ',
  ForPleaseChooseUnprovisionedBusiness: 'เป็นธุรกิจบริการแล้ว โปรดเลือกธุรกิจที่ยังไม่นับคะแนน!',
  ProvisionSuccess: 'นับคะแนนสำเร็จ',
  CancellationProvisionsSuccess: 'ยกเลิกนับคะแนนสำเร็จ',
  ProvisionReview: 'การตรวจสอบนับคะแนน',
  ProvisionDate: 'วันที่นับคะแนน',
  Booking: 'การจองพื้นที่',
  CustomsClearance: 'การศุลกากร',
  FormalHouseWaybill: 'แยกแผ่นรูปแบบ',
  CommodityInspection: 'การตรวจสอบสินค้า',
  Fumigation: 'การรมยา',
  ForeignTrade: 'การค้าระหว่างประเทศ',
  CustomerAttribute: 'คุณสมบัติลูกค้า',
  Dropdown: 'ดึงลง',
  OrderChannel: 'ช่องทางการสั่งซื้อ',
  ArrivalDate: 'วันที่ถึงท่าเรือ',
  ShippingOfBillOfLading: 'สถานที่ออกใบตราส่ง',
  OriginPortPOL: 'ท่าเรือต้นทาง(POL)',
  DeliveryPlace: 'สถานที่ส่งมอบ',
  Route: 'เส้นทางเดินเรือ',
  FinalDestination: 'จุดหมายปลายทางสุดท้าย',
  ShippingCompany: 'บริษัทเรือ',
  ShipAgent: 'ตัวแทนเรือ',
  TradeMethod: 'วิธีการค้า',
  MasterWaybillTransportTerms: 'ข้อกำหนดการขนส่งรายการหลัก',
  HouseWaybillTransportTerms: 'ข้อกำหนดการขนส่งแยกแผ่น',
  MasterWaybillFreightTerms: 'ข้อกำหนดค่าโดยสารรายการหลัก',
  MasterWaybillPaymentLocation: 'สถานที่ชำระเงินรายการหลัก',
  HouseWaybillFreightTerms: 'ข้อกำหนดค่าโดยสารแยกแผ่น',
  HouseWaybillPaymentLocation: 'สถานที่ชำระเงินแยกแผ่น',
  TradeTerms: 'ข้อกำหนดการค้า',
  CargoDimensions: 'ขนาดสินค้า',
  SpecialPriceExplanation: 'คำอธิบายราคาพิเศษ',
  GrossWeightEntrustedActual: 'น้ำหนักรวม (ตามใบสั่ง/จริง)',
  VolumeEntrustedActual: 'ปริมาตร (ตามใบสั่ง/จริง)',
  Packing: 'บรรจุภัณฑ์',
  NumberOfSmallPieces: 'จำนวนชิ้นเล็ก',
  SmallPiecePacking: 'บรรจุภัณฑ์ชิ้นเล็ก',
  ChargeableWeightRT: 'น้ำหนักคิดค่า RT',
  EnglishProductName: 'ชื่อสินค้าภาษาอังกฤษ',
  ShippingMarks: 'เครื่องหมาย',
  HSCode: 'รหัส HS',
  ChineseProductName: 'ชื่อสินค้าภาษาจีน',
  CargoSales: 'การขายและการรับสินค้า',
  OperatingCompany: 'บริษัทดำเนินการ',
  OperatingDepartment: 'แผนกดำเนินการ',
  OperationRequirements: 'ข้อกำหนดการดำเนินการ',
  OperationTips: 'คำแนะนำการดำเนินการ',
  AdditionalFeeTerms: 'ข้อกำหนดค่าธรรมเนียมเพิ่มเติม',
  WarehouseEntryInformation: 'ข้อมูลการรับเข้าคลัง',
  Remarks: 'หมายเหตุ',
  CustomField4: 'ฟิลด์กำหนดเอง 4',
  Shipper: 'ผู้ส่งสินค้า',
  SecondNotifyParty: 'ผู้แจ้งเตือนรอง',
  EntrustedInformation: 'ข้อมูลการมอบหมาย',
  VipCooperativeCustomer: 'ลูกค้าร่วมงาน VIP',
  DetailedInformation: 'รายละเอียด',
  Transshipment: 'การขนส่งต่อ',
  AdditionalInformation: 'ข้อมูลเพิ่มเติม',
  DoorToDoorLoadingCollection: 'การบรรจุ/รับสินค้าที่จุด',
  SelfPickupSelfDelivery: 'ขนส่งเอง',
  AutomaticAllocation: 'การจัดสินค้าอัตโนมัติ',
  WarehousingInformation: 'รับเข้าคลัง',
  CargoBoxInformation: 'ข้อมูลสินค้าในกล่อง',
  OperationInformation: 'ข้อมูลการดำเนินการ',
  CustomInformation: 'ข้อมูลกำหนดเอง',
  CustomerShippingInformation: 'ข้อมูลการส่งสินค้าของลูกค้า',
  CodeRetrieval: 'การค้นหารหัส',
  OperationCannotBeEmpty: 'การดำเนินการไม่สามารถเว้นว่างได้',
  OperationDepartmentCannotBeEmpty: 'แผนกดำเนินการไม่สามารถเว้นว่างได้',
  OperationBranchCannotBeEmpty: 'สาขาดำเนินการไม่สามารถเว้นว่างได้',
  DesignatedFreightAgent: 'ตัวแทนสินค้าที่กำหนด',
  DeparturePortAgent: 'ตัวแทนท่าเรือต้นทาง',
  Client: 'หน่วยมอบหมาย',
  DeclaringCustoms: 'มีการสำแดงศุลกากรหรือไม่',
  ContainerPackingWarehouse: 'การบรรจุภายใน/คลังสินค้า',
  WarehouseService: 'มีการจัดเก็บหรือไม่',
  PricingNature: 'ลักษณะราคาตกลง',
  BookingNature: 'ลักษณะการจองพื้นที่',
  PleaseARecordToView: 'กรุณาเลือกหนึ่งรายการเพื่อดู',
  WriteOff: 'ยกเลิกทั้งหมด',
  AgeOfAccount: 'อายุบัญชีของตั๋วนี้',
  CommissionAmount: 'จำนวนเงินค่าคอมมิชชั่น',
  TradeType: 'ประเภทการค้า',
  PayableWriteOffStatus: 'สถานะการตัดจ่าย',
  ReceivableWriteOffStatus: 'สถานะการตัดรับ',
  Date: 'วันที่',
  PleaseEnterTheReviewDate: 'กรุณากรอกวันที่ตรวจสอบ',
  PleaseConfirmTheReviewDate: 'กรุณายืนยันวันที่ตรวจสอบ',
  FailedToGetDetails: 'ไม่สามารถดึงข้อมูลรายละเอียด',
  AfterForFinancialReviewContinue: 'หลังจากพิมพ์รายงานวิเคราะห์กำไรแล้ว งานนี้จะถูกส่งไปตรวจสอบทางการเงินและไม่สามารถแก้ไขได้อีก ต้องการดำเนินการต่อหรือไม่?',
  Warning: 'คำเตือน',
  PleaseNumberBeforePrintingTable: 'กรุณากรอกหมายเลขซีลลังก่อนพิมพ์รายงานวิเคราะห์กำไร',
  PleaseSelectCost: 'กรุณาเลือกค่าใช้จ่าย',
  ConfirmTheSingleCostDate: 'แน่ใจหรือไม่ที่จะแก้ไขวันที่ทางการเงินของรายการค่าใช้จ่ายนี้?',
  CostFinancialDateModificationSuccessful: 'แก้ไขวันที่ทางการเงินของค่าใช้จ่ายสำเร็จ',
  ConfirmModifyTheFinancialDate: 'แน่ใจหรือไม่ที่จะแก้ไขวันที่ทางการเงิน?',
  FinancialDateModificationSuccessful: 'แก้ไขวันที่ทางการเงินสำเร็จ',
  ReviewBusinessDateDoContinue: 'วันที่ตรวจสอบน้อยกว่าวันที่ดำเนินงาน ต้องการดำเนินการต่อหรือไม่?',
  ConfirmReviewOfTheseOrders: 'แน่ใจหรือไม่ที่จะตรวจสอบรายการเหล่านี้?',
  ThisIsNotIn: 'งานนี้ไม่ได้อยู่ในสถานะ [',
  AllowedToReviewCheck: '] ไม่สามารถตรวจสอบได้ กรุณาตรวจสอบ!',
  ConfirmToAllowAmendments: 'แน่ใจหรือไม่ที่จะอนุญาตให้แก้ไขรายการ?',
  AmendmentAllowedSuccessful: 'อนุญาตให้แก้ไขรายการสำเร็จ',
  NoOrNotInStatus: 'ยังไม่ได้เลือกค่าใช้จ่ายหรือไม่อยู่ในสถานะตรวจสอบ',
  ConfirmCancellationOfReview: 'แน่ใจหรือไม่ที่จะยกเลิกการตรวจสอบ?',
  CostStatusUpdateSuccessful: 'อัปเดตสถานะค่าใช้จ่ายสำเร็จ',
  NoOrNotInStatus2: 'ยังไม่ได้เลือกค่าใช้จ่ายหรือไม่อยู่ในสถานะส่ง',
  NoOrNotInStatus3: 'ยังไม่ได้เลือกค่าใช้จ่ายหรือไม่อยู่ในสถานะตรวจสอบ!',
  NoOrNotInStatus4: 'ยังไม่ได้เลือกค่าใช้จ่ายหรือไม่อยู่ในสถานะส่ง!',
  ConfirmToCancelReview: 'แน่ใจหรือไม่ที่จะยกเลิกการตรวจสอบ?',
  CancelReviewSuccessful: 'ยกเลิกการตรวจสอบสำเร็จ',
  LCLIndividuallyPleaseReviewBill: 'ไม่สามารถตรวจสอบบิลรวมแยกได้ กรุณาตรวจสอบบิลหลัก',
  FrontEndErrorCallbackFailed: 'ข้อผิดพลาดส่วนหน้า: การเรียกกลับล้มเหลว',
  CostStatusUpdateSuccessful2: 'อัปเดตสถานะค่าใช้จ่ายสำเร็จ',
  PleaseStaffInformationBeforePrinting: 'กรุณากรอกข้อมูลพนักงานขายก่อนพิมพ์!',
  TheNotEnteredSales: 'คำสั่งต่อไปนี้ไม่ได้ป้อนข้อมูลพนักงานขาย：\n',
  PleaseEnterBeforePrinting: '\nกรุณากรอกข้อมูลก่อนพิมพ์！',
  PleaseWantToModifyDate: 'กรุณาเลือกงานที่ต้องการแก้ไขวันที่ดำเนินงาน',
  BusinessDateModificationSuccessful: 'แก้ไขวันที่ดำเนินงานสำเร็จ',
  PleaseSelectOnlyOneRecord: 'กรุณาเลือกเพียงหนึ่งรายการ',
  InvoicePool_OnlyWithAttachment: 'มีไฟล์แนบ',
  PleaseSelectBusiness: 'กรุณาเลือกงาน',
  SelectedDataIncludes: 'ข้อมูลที่เลือกประกอบด้วย',
  StatusAllowedToReviewCheck: 'งานที่มีสถานะ ไม่สามารถตรวจสอบได้ กรุณาตรวจสอบ!',
  StatusToCancelReviewCheck: 'งานที่มีสถานะ ไม่สามารถยกเลิกการตรวจสอบได้ กรุณาตรวจสอบ!',
  BatchReviewFailed: 'การตรวจสอบแบบกลุ่มล้มเหลว',
  ReviewLessThanBusinessContinue: 'วันที่ตรวจสอบน้อยกว่าวันที่ดำเนินงาน ต้องการดำเนินการต่อหรือไม่?',
  ConfirmToReviewTheseOrders: 'แน่ใจหรือไม่ที่จะตรวจสอบรายการเหล่านี้?',
  FinancialReviewList: 'รายการตรวจสอบทางการเงิน',
  QueryFailed: 'การค้นหาล้มเหลว',
  PleaseBusinessYouWantPrint: 'กรุณาเลือกงานที่ต้องการพิมพ์',
  SendEmail: 'ส่งอีเมล',
  N1ContactAndEmailMaintained: '1.ยังไม่ได้บำรุงรักษาผู้ติดต่อและอีเมล:',
  N1AMaintainedContactEmail: '1.กรุณาเลือกผู้ติดต่อและอีเมลที่บำรุงรักษาแล้ว:',
  N2PleaseAddOtherEmails: '2.กรุณาเพิ่มอีเมลอื่น:',
  MultipleShouldBeSeparatedCommas: '(กรุณาแยกที่อยู่อีเมลหลายรายการด้วยเครื่องหมายจุลภาค)',
  Send: 'ส่ง',
  InvoiceUuidCannotBeEmpty: 'uuid ของใบแจ้งหนี้ไม่สามารถเว้นว่างได้!',
  SettlementIdCannotBeEmpty: 'ไอดีหน่วยชำระเงินไม่สามารถเว้นว่างได้!',
  PleaseEnterEmail: 'กรุณากรอกอีเมล',
  SendLog: 'บันทึกการส่ง',
  Sender: 'ผู้ส่ง',
  YouViewOtherPeoplesFiles: 'คุณไม่มีสิทธิ์ในการดูไฟล์ที่อัปโหลดหรือพิมพ์โดยบุคคลอื่น',
  CostName: 'ชื่อค่าใช้จ่าย',
  PaymentType: 'ประเภทการรับ/จ่าย',
  BillingExchangeRate: 'อัตราแลกเปลี่ยนในการออกใบแจ้งหนี้',
  BillingAmount: 'จำนวนเงินในใบแจ้งหนี้',
  BillBusinessNumber: 'เลขที่บิล/ธุรกิจ',
  BillBusinessDate: 'วันที่บิล/ธุรกิจ',
  PriceExclusiveOfTax: 'ราคาไม่รวมภาษี',
  ResetColumn: 'รีเซ็ตคอลัมน์',
  OnlyNumberCanBeSelected: 'สามารถเลือกได้เพียง 1 เลขที่ใบแจ้งหนี้!',
  Used: 'ใช้งานแล้ว',
  Example8180onlyUSDIsInvoice: 'ตัวอย่าง: USD:355/อัตราแลกเปลี่ยน:6.8180/ใบแจ้งหนี้นี้รับเฉพาะดอลลาร์สหรัฐ',
  PleaseNote: 'ข้อควรระวัง:',
  ChangesTheNextInvoiceConfiguration: 'การตั้งค่าจะมีผลใช้บังคับตั้งแต่ใบแจ้งหนี้ฉบับถัดไปหลังจากบันทึก',
  EBeLessThanCharacters: 'หมายเหตุใบแจ้งหนี้อิเล็กทรอนิกส์ต้องน้อยกว่า 100 ตัวอักษร',
  PaperBeLessThanCharacters: 'หมายเหตุใบแจ้งหนี้กระดาษต้องน้อยกว่า 200 ตัวอักษร',
  AutomaticTheTextDoesntLine: 'จะขึ้นบรรทัดใหม่อัตโนมัติเมื่อแสดงไม่พอในหนึ่งบรรทัด',
  PDFDisplayUpToLines: 'ช่องหมายเหตุใบแจ้งหนี้รูปแบบ PDF แสดงได้สูงสุดสามบรรทัด',
  InvoiceType: 'ประเภทใบแจ้งหนี้',
  RMBExpenseItemName: 'ชื่อรายการค่าใช้จ่าย RMB',
  USDExpenseItem: 'รายการค่าใช้จ่าย USD',
  DefaultItemName: 'เป็นชื่อรายการเริ่มต้นหรือไม่',
  Billing: 'ออกใบแจ้งหนี้',
  Add: 'เพิ่ม',
  InternationalFreightForwardingFee: 'ค่าขนส่งตัวแทนระหว่างประเทศ',
  InternationalShippingFee: 'ค่าขนส่งทางเรือตัวแทนระหว่างประเทศ',
  InternationalFreightServiceFee: 'ค่าบริการตัวแทนขนส่งสินค้าระหว่างประเทศ',
  FreightForwardingFee: 'ค่าตัวแทนขนส่งสินค้า',
  MarkBill: 'ทำเครื่องหมายบิล',
  MarkCharge: 'เครื่องหมายค่าใช้จ่าย',
  MarkJob: 'เครื่องหมายธุรกิจ',
  PleaseSelectChargeToMark: 'กรุณาเลือกค่าใช้จ่ายที่ต้องการเครื่องหมาย',
  MarkRecordExistsMarkedCharge: 'ในระเบียนมีค่าใช้จ่ายที่ถูกเครื่องหมายแล้ว กรุณาเลือกค่าใช้จ่ายที่ยังไม่ได้เครื่องหมาย',
  PleaseSelectJobToMark: 'กรุณาเลือกธุรกิจที่ต้องการเครื่องหมาย',
  MarkRecordExistsMarkedJob: 'ในระเบียนมีธุรกิจที่ถูกเครื่องหมายแล้ว กรุณาเลือกธุรกิจที่ยังไม่ได้เครื่องหมาย',
  MarkRecordExistsNoMarkedCharge: 'ในระเบียนมีค่าใช้จ่ายที่ยังไม่ได้标记 กรุณาเลือกค่าใช้จ่ายที่ถูก标记แล้ว',
  MarkRecordExistsNoMarkedJob: 'ในระเบียนมีธุรกิจที่ยังไม่ได้标记 กรุณาเลือกธุรกิจที่ถูก标记แล้ว',
  AnnotationDate: 'วันที่ทำเครื่องหมาย:',
  Annotator: 'ผู้ทำเครื่องหมาย:',
  InvoiceInquiry: 'ค้นหาใบแจ้งหนี้',
  QuickSearchInvoiceNumber: 'ค้นหาด่วน: เลขที่ใบแจ้งหนี้',
  SecondaryDownload: 'ดาวน์โหลดครั้งที่',
  Sent: 'ส่งแล้ว',
  Unsent: 'ยังไม่ได้ส่ง',
  Total: 'รวม',
  VoidingBulkOperationsPleaseSelectClickVoid: 'การยกเลิกใบแจ้งหนี้ไม่รองรับการดำเนินการเป็นกลุ่ม\nกรุณาเลือกใบแจ้งหนี้ 1 ฉบับก่อนคลิก【ยกเลิก】',
  OriginalToReissueTheExpenses: 'ค่าใช้จ่ายเดิมจะถูกยกเลิกด้วยใบแดง หากต้องการออกใบแจ้งหนี้ใหม่ โปรดระมัดระวังในการเพิ่มค่าใช้จ่ายที่ถูกต้อง!',
  OriginalTheSystemWillExpenses: 'ค่าใช้จ่ายเดิมจะถูกยกเลิกด้วยใบแดง ระบบจะสร้างค่าใช้จ่ายที่เหมือนกับค่าใช้จ่ายเดิมโดยอัตโนมัติ!',
  CreditSuccess: 'การยกเลิกสำเร็จ!',
  BankAccount: 'บัญชีธนาคาร',
  OnlyElectronicInvoicesPleaseType: 'รองรับเฉพาะการดาวน์โหลดใบแจ้งหนี้อิเล็กทรอนิกส์แบบกลุ่ม กรุณาตรวจสอบประเภทใบแจ้งหนี้',
  TotalSelection: 'เลือกทั้งหมด',
  StatusUnknown: 'สถานะไม่ทราบ',
  UnwrittenAmount: 'ยอดที่ยังไม่ได้ตัด',
  WrittenOffAmount: 'ยอดที่ตัดแล้ว',
  SearchByExpense: 'ค้นหาตามค่าใช้จ่าย',
  QuickSearchBusinessNumber: 'ค้นหาด่วน: เลขที่ธุรกิจ',
  SearchByBusiness: 'ค้นหาตามธุรกิจ',
  SearchByBill: 'ค้นหาตามบิล',
  QuickSearchBillNumber: 'ค้นหาด่วน: เลขที่บิล',
  SearchByReconciliationBill: 'ค้นหาตามใบแจ้งยอด',
  QuickSearchReconciliationBillNumber: 'ค้นหาด่วน: เลขที่ใบแจ้งยอด',
  SearchByExpenseCredit: 'ค้นหาตามค่าใช้จ่าย(ยกเลิก)',
  SearchByBusinessCredit: 'ค้นหาตามธุรกิจ(ยกเลิก)',
  SearchByBillCredit: 'ค้นหาตามบิล(ยกเลิก)',
  SearchByReconciliationBillCredit: 'ค้นหาตามใบแจ้งยอด(ยกเลิก)',
  SearchingYouSureYouAgo: 'หากเลือกช่วงเวลามากกว่า 2 ปี อาจทำให้การโหลดข้อมูลช้าลง ยืนยันที่จะค้นหาข้อมูลนอกเหนือจาก 2 ปีหรือไม่?',
  SelectClosingDate: 'เลือกวันที่ปิดบัญชี',
  ClosingDate: 'วันที่ปิดบัญชี:',
  FinancialClosing: 'ปิดบัญชีทางการเงิน',
  BusinessClosing: 'ปิดบัญชีทางธุรกิจ',
  ClosingPerson: 'ผู้ปิดบัญชี',
  ClosingMonth: 'เดือนที่ปิดบัญชี',
  ClosingBranch: 'สาขาที่ปิดบัญชี',
  ClosingType: 'ประเภทการปิดบัญชี',
  TheHasAlreadyBeenClosed: 'เดือนที่เลือกได้ปิดบัญชีไปแล้ว',
  ClosingSuccess: 'ปิดบัญชีสำเร็จ',
  PleaseSelectAClosingRecord: 'กรุณาเลือกรายการปิดบัญชี',
  TheBeenAuditedAndCancelled: 'รายการปิดบัญชีได้รับการตรวจสอบแล้ว ไม่สามารถยกเลิกได้',
  AreWantToCancelRecord: 'ยืนยันที่จะยกเลิกรายการปิดบัญชีหรือไม่?',
  ClosingRecordCancelled: 'ยกเลิกรายการปิดบัญชีแล้ว',
  Year: 'ปี',
  Month: 'เดือน',
  PleaseSelectARecord: 'กรุณาเลือกรายการ',
  AreWantToAuditRecord: 'หลังจากตรวจสอบแล้วไม่สามารถยกเลิกรายการปิดบัญชีได้ ยืนยันหรือไม่?',
  OperationSuccessful: 'ดำเนินการสำเร็จ',
  ToYouSureYouAudit: 'หลังจากยกเลิกการตรวจสอบสามารถยกเลิกวันที่ปิดบัญชีได้ ยืนยันหรือไม่?',
  NoMatchingPrintTemplatesFound: 'ไม่พบเทมเพลตการพิมพ์ที่ตรงกัน',
  FinancialAudit: 'การตรวจสอบทางการเงิน',
  HangingWaterBill: 'ใบสั่งน้ำเกลือ',
  ReceivedPayment: 'รับเงิน',
  GotReceipt: 'ได้รับใบตอบรับ',
  InternationalBill: 'บิลต่างประเทศ',
  AgencySharingBill: 'บิลแบ่งส่วนตัวแทน',
  PaymentRequestQuery: 'ค้นหาคำร้องขอชำระเงิน',
  QuickSearchPaymentRequestNumber: 'ค้นหาด่วน: เลขที่คำร้องขอชำระเงิน',
  ChangeExpenseApplicationQuery: 'ค้นหาคำร้องขอเปลี่ยนค่าใช้จ่าย',
  QuickSearchApplicationSerialNumber: 'ค้นหาด่วน: เลขที่คำร้อง',
  SearchByInvoice: 'ค้นหาตามใบแจ้งหนี้',
  BankAccountNumber: 'บัญชีธนาคาร',
  NoCorrespondingPrintTemplateFound: 'ไม่พบเทมเพลตการพิมพ์ที่เกี่ยวข้อง',
  SearchByCost: 'ค้นหาตามค่าใช้จ่าย',
  ReleasePleasePrepareForWithholding: 'เอกสารได้ถูกปล่อยแล้ว โปรดเตรียมการสินค้าหัวเข็มขัด',
  StatusUpdatedSuccessfully: 'อัปเดตสถานะสำเร็จ',
  BillOfLadingConfirmationDocument: 'เอกสารยืนยันใบตราส่งสินค้า',
  DataCustomersReleaseNotAllowed: 'ข้อมูลมีลูกค้าที่อยู่ในแบล็กลิสต์ ห้ามปล่อยเอกสาร!',
  AreToUseAnNumber: 'ยืนยันที่จะใช้หมายเลขปล่อยเอกสารที่ว่างเปล่าใช่หรือไม่?',
  Invoice: 'ออกใบแจ้งหนี้',
  EquivalentToRMB: 'เทียบเท่า RMB:',
  ReconciliationFlowNumber: 'หมายเลขน้ำไหลการตัดบัญชี',
  CounterpartyUnit: 'หน่วยงานคู่สัญญา',
  OurBank: 'ธนาคารฝ่ายเรา',
  PaymentNoticeNumber: 'หมายเลขแจ้งการชำระเงิน',
  VoucherNumber: 'หมายเลขหลักฐาน',
  BankSlipNumber: 'หมายเลขสลิปธนาคาร',
  ReconciliationPerson: 'ผู้ตัดบัญชี',
  ReconciliationDate: 'วันที่ตัดบัญชี',
  ReceiptpaymentDate: 'วันที่รับ/จ่าย',
  VoucherDate: 'วันที่ออกหลักฐาน',
  SlipStatus: 'สถานะสลิป',
  ReceiptpaymentMethod: 'วิธีการรับ/จ่าย',
  WhetherPrepaid: 'เป็นการชำระล่วงหน้าหรือไม่',
  Amount: 'จำนวนเงิน',
  AmountReconciled: 'จำนวนเงินที่ตัดบัญชีแล้ว',
  Balance: 'ยอดคงเหลือ',
  ActualAmountReceived: 'จำนวนเงินที่ได้รับจริง',
  ActualPaymentAmount: 'จำนวนเงินที่จ่ายจริง',
  FinancialExpense: 'ค่าใช้จ่ายทางการเงิน',
  ExchangeGainloss: 'กำไร/ขาดทุนจากการแลกเปลี่ยน',
  SmallHead: 'ยอดขาดเล็กน้อย',
  OriginalCurrencyDifference: 'ส่วนต่างอัตราแลกเปลี่ยนสกุลเงินเดิม',
  Review: 'ตรวจสอบ',
  ReviewDate: 'วันที่ตรวจสอบ',
  Void: 'ยกเลิก',
  InvoiceInformation: 'ข้อมูลการออกใบแจ้งหนี้',
  AccountPerioddays: 'ระยะเวลาบัญชี (วัน)',
  CounterpartyVoucherNumber: 'หมายเลขหลักฐานฝ่ายตรงข้าม',
  VoucherDate2: 'วันที่ออกหลักฐาน 2',
  FailedToModifyReconciliation: 'แก้ไขการตัดบัญชีไม่สำเร็จ',
  OffsetSearchAndSelectThe: 'การตัดบัญชี对冲: โปรดค้นหาและเลือกทั้งหมดที่ต้องการ对冲',
  Fees: 'ค่าใช้จ่าย',
  Invoices: 'ใบแจ้งหนี้',
  Statements: 'บิล',
  AccountStatements: 'ใบแจ้งยอด',
  PaymentApplications: 'คำร้องขอชำระเงิน',
  PlatformCustomerService: 'บริการลูกค้าของแพลตฟอร์ม',
  FailedToRevokeReconciliation: 'ยกเลิกการตัดบัญชีไม่สำเร็จ',
  Equivalent: 'เทียบเท่า',
  PaymentAmount: 'จำนวนเงินที่ชำระ',
  PaymentMethod: 'วิธีการชำระเงิน',
  NotUsed: 'ยังไม่ได้ใช้',
  PendingSlip: 'ใบแจ้งหนี้ที่ค้าง',
  ReceivedReceipt: 'ได้รับใบเสร็จรับเงิน',
  Reconciliation: 'ตัดจ่าย',
  Company1: 'บริษัท 1',
  CloseAndCopyFlowNumber: 'ปิดและคัดลอกเลขที่อ้างอิง',
  Close: 'ปิด',
  CopySuccessful: 'คัดลอกสำเร็จ',
  IfLoadingSpeedAreAgo: 'หากเลือกช่วงเวลามากกว่า 2 ปี อาจทำให้การโหลดข้อมูลช้าลง คุณแน่ใจหรือไม่ที่จะค้นหาข้อมูลที่เกิน 2 ปี?',
  FinancialComprehensiveQuery: 'การค้นหาข้อมูลทางการเงินแบบรวม',
  ExportEstimationForm: 'ส่งออกตารางประมาณการ',
  ExportingMailboxLaterPleaseMailbox: 'กำลังส่งออก ไฟล์จะถูกส่งไปยังอีเมลของผู้เข้าสู่ระบบในภายหลัง โปรดตรวจสอบไฟล์ในอีเมล',
  ChineseName: 'ชื่อภาษาจีน',
  ClosingRecords: 'บันทึกการปิดบัญชี',
  ClosingReview: 'การตรวจสอบการปิดบัญชี',
  PleaseCheckARecord: 'โปรดเลือกหนึ่งรายการ',
  PleaseAReconciliationRuleName: 'โปรดป้อนชื่อกฎการตรวจสอบ',
  PleaseSelectABranch: 'โปรดเลือกสาขา',
  DeleteSuccessful: 'ลบสำเร็จ',
  PleaseReconciliationRuleToEdit: 'โปรดเลือกกฎการตรวจสอบเพื่อแก้ไข',
  PleaseTheMatchingFieldOrder: 'โปรดป้อนลำดับฟิลด์ที่ตรงกัน',
  PleaseTheMatchingFieldName: 'โปรดเลือกชื่อฟิลด์ที่ตรงกัน',
  PleaseTheContrastFieldOrder: 'โปรดป้อนลำดับฟิลด์เปรียบเทียบ',
  PleaseTheContrastFieldName: 'โปรดเลือกชื่อฟิลด์เปรียบเทียบ',
  PleaseTheContrastFieldOperation: 'โปรดเลือกการดำเนินการฟิลด์เปรียบเทียบ',
  EnterReconciliationAmount: 'โปรดป้อน【จำนวนเงินตรวจสอบ】ในตารางภายใน และตรวจสอบให้แน่ใจว่าจำนวนเงินตรวจสอบที่เลือกทั้งสองด้านตรงกันก่อนทำการตรวจสอบด้วยตนเอง',
  XNotAllowViewOrDownload: 'ไฟล์ {0} ไม่อนุญาตให้任何人ดูหรือดาวน์โหลด',
  NoPermissionView: 'คุณไม่มีสิทธิ์ในการดูหรือดาวน์โหลดไฟล์ {0}',
  SelectedNotAllowedToCheck: 'ข้อมูลที่เลือกมีธุรกิจที่ไม่ใช่สถานะ {0} ไม่สามารถตรวจสอบได้ โปรดตรวจสอบ!',
  N0isBeVoidedPleaseNote: '【{0}】เป็นใบแจ้งหนี้อิเล็กทรอนิกส์ ไม่สามารถยกเลิกได้ โปรดทำการยกเลิกด้วยการออกใบใหม่',
  N0isCannotBeVoidedNote: '【{0}】เป็นใบแจ้งหนี้ข้ามเดือน ไม่สามารถยกเลิกได้ โปรดทำการยกเลิกด้วยการออกใบใหม่',
  N0VoidedAndCannotCredited: '{0} ถูกยกเลิกแล้ว ไม่สามารถยกเลิกด้วยการออกใบใหม่ได้!',
  N0hasOffAndCannotCredited: '{0} ถูกตัดจ่ายแล้ว ไม่สามารถยกเลิกด้วยการออกใบใหม่ได้!',
  N0ItemsDownloadable: 'รายการ สามารถดาวน์โหลดได้',
  N0ItemsConfirmDownload: 'รายการ ยืนยันที่จะดาวน์โหลดหรือไม่?',
  TelexContact0ToApplication: 'ได้ทำการขอปล่อยสินค้าแล้ว โปรดติดต่อ {0} เพื่อยกเลิกการขอปล่อยสินค้า',
  DocumentaryStatus: 'สถานะการสร้างเอกสาร',
  GotIt: 'เข้าใจแล้ว',
  CurrencyConversionColumnSet: 'การตั้งค่าคอลัมน์แสดงสกุลเงินแปลง',
  CurrencyConversionSet: 'การตั้งค่าสกุลเงินแปลง',
  ShowColumns: 'คอลัมน์ที่แสดง',
  CurrencyConversionColumnSetNote: 'หมายเหตุ: เมื่อเลือกสกุลเงินแล้ว ระบบจะสร้างคอลัมน์แสดงจำนวนเงินต้นหรือจำนวนเงินที่แปลงเป็นสกุลเงินที่เลือกโดยอัตโนมัติ',
  CheckAtLeastOneDisplayColumn: 'โปรดเลือกอย่างน้อยหนึ่งคอลัมน์ที่แสดง',
  InvoiceWrittenOffWantDeleteIt: 'ใบแจ้งหนี้ถูกตัดจ่ายแล้ว ยืนยันที่จะลบหรือไม่?',
  InvoiceWrittenOffWantRevokedIt: 'ใบแจ้งหนี้ถูกตัดจ่ายแล้ว ยืนยันที่จะยกเลิกหรือไม่?',
  InvoiceWrittenOffWantRedPunchIt: 'ใบแจ้งหนี้ถูกตัดจ่ายแล้ว ยืนยันที่จะยกเลิกด้วยการออกใบใหม่หรือไม่?',
  RedPunchInvoice: 'ใบแจ้งหนี้ยกเลิกด้วยการออกใบใหม่',
  BatchCheckRedFlushInvoiceMessageOne: '1. หากเลือกว่าการออกใบแจ้งหนี้มีข้อผิดพลาด ระบบจะสร้างค่าใช้จ่ายใหม่ที่รอออกใบแจ้งหนี้ตามค่าใช้จ่ายเดิมโดยอัตโนมัติ',
  BatchCheckRedFlushInvoiceMessageTwo: '2.หากเลือกยกเลิกบริการ ส่วนลดการขาย หรือคืนสินค้า โปรดระวังการป้อนค่าใช้จ่ายที่ถูกต้องด้วยตนเอง',
  BatchCheckRedFlushInvoiceMessageThree: '2.หากเลือกยกเลิกบริการหรือส่วนลดการขาย โปรดระวังการป้อนค่าใช้จ่ายที่ถูกต้องด้วยตนเอง',
  IncorrectInvoiceInformation: 'ข้อมูลใบแจ้งหนี้ไม่ถูกต้อง',
  IncorrectChargeInformation: 'ข้อมูลค่าใช้จ่ายไม่ถูกต้อง',
  BatchCheckRedPunchInvoiceMessageOne: '1.หากเลือกว่าข้อมูลใบแจ้งหนี้ไม่ถูกต้อง ระบบจะสร้างค่าใช้จ่ายใหม่ที่รอออกใบแจ้งหนี้โดยอัตโนมัติตามค่าใช้จ่ายเดิม',
  BatchCheckRedPunchInvoiceMessageTwo: '2.หากเลือกว่าข้อมูลค่าใช้จ่ายไม่ถูกต้อง โปรดระวังการป้อนค่าใช้จ่ายที่ถูกต้องด้วยตนเอง',
  ContinueRedPunchAtVoucher: 'ใบแจ้งหนี้ที่มีหมายเลขใบสำคัญที่สร้างแล้ว โปรดยืนยันว่าจะทำการยกเลิกหรือไม่?',
  WhtDeduction: 'หักภาษี ณ ที่จ่าย (WHT)',
  WhtDeductionAmount: 'จำนวนที่หักภาษี ณ ที่จ่าย (WHT)',
  ReceivableWHTTaxAmount: 'ลูกหนี้หักภาษี ณ ที่จ่าย (WHT)',
  PayableWHTTaxAmount: 'เจ้าหนี้หักภาษี ณ ที่จ่าย (WHT)',
  TotalExcludingTax: 'รวม (ไม่รวมภาษี)',
  TotalIncludingTax: 'รวม (รวมภาษี)',
  NewGeneration: 'สถานะการส่งไปยังระบบคนรุ่นใหม่',
  PushState: 'สถานะ Push',
  PushFailReason: 'สาเหตุของการผลักดันล้มเหลว',
  ManualMatching: 'การจับคู่ด้วยมือ',
  SelectBusinessNumber: 'เลือกหมายเลขธุรกรรมที่เกี่ยวข้อง',
  ManualMatchByBoxNo: 'จับคู่ด้วยมือตามหมายเลขกล่อง',
  ManualMatchByWarehouseNo: 'จับคู่ด้วยมือตามหมายเลขรับเข้าคลัง',
  FreeMatch: 'การจับคู่แบบอิสระ',
  SelectSameSupplierNumberMatch: 'โปรดเลือกหมายเลขผู้ขายเข้าเดียวกันเพื่อทำการจับคู่ด้วยมือ',
  BusinessNoMblSoNoNotEmpty: 'หมายเลขธุรกรรม หมายเลขเอกสารหลัก และ SO NO ไม่สามารถเว้นว่างทั้งหมดได้',
  SelectCorrespondeBusiness: 'โปรดเลือกธุรกรรมที่เกี่ยวข้อง',
  CostSyncColudStatus: 'สถานะการซิงค์ค่าใช้จ่ายกับคลาวด์แพลตฟอร์ม',
  SyncCloudExceptionReason: 'สาเหตุความผิดปกติในการซิงค์กับคลาวด์แพลตฟอร์ม',
  ManualSynchronization: 'การซิงค์ด้วยมือ',
  SelectNotSyncManualPush: 'โปรดเลือกข้อมูลที่มีสถานะซิงค์เป็นยังไม่ซิงค์ เพื่อทำการส่งด้วยมือ',
  SyncChargeNotSplit: 'ค่าใช้จ่ายที่ซิงค์แล้ว ไม่สามารถแบ่งย่อยได้',
  SyncCloudPlatformStatus: 'สถานะการซิงค์กับคลาวด์แพลตฟอร์ม',
  InvoiceNoEmptyNotPush: 'หมายเลขใบแจ้งหนี้ว่างเปล่า ไม่สามารถส่งได้',
  InvoicePushNotAgain: 'ใบแจ้งหนี้ที่ส่งแล้ว โปรดอย่าส่งซ้ำ',
  SentYongYouRedFlush: 'ส่งไปยัง Yonyou แล้ว โปรดทำการยกเลิก',
  InvoiceTitleNotSync: 'ส่วนหัวใบแจ้งหนี้ "{0}" ยังไม่ได้ซิงค์กับ Yonyou โปรดซิงค์ก่อน',
  OnlySupportInternal: 'อินเทอร์เฟซไม่รวมค่าใช้จ่ายต่างประเทศ โปรดเลือกใบแจ้งหนี้ในประเทศ',
  NotSupportMultiCurrency: 'มีสกุลเงินใบแจ้งหนี้ผสมกัน ไม่สามารถส่งไปยัง Yonyou ได้ โปรดปรับปรุงข้อมูล',
  OnlySupportRmb: 'สกุลเงินใบแจ้งหนี้ไม่ใช่ RMB ไม่สามารถส่งไปยัง Yonyou ได้',
  PayableInvoiceActualReceiptDateEmpty: 'วันที่รับใบแจ้งหนี้จริงของเจ้าหนี้ไม่สามารถเว้นว่างได้ โปรดกรอกก่อน',
  PushYongYouInvoiceNeedRMB: 'การส่งใบแจ้งหนี้ไปยัง Yonyou ต้องใช้สกุลเงินใบแจ้งหนี้เป็น RMB',
  OffsetRedPunchTipU8C: 'ตามข้อกำหนดของกลุ่ม ใบแจ้งหนี้ที่ยกเลิกไม่สามารถส่งได้ โปรดดำเนินการแบบออฟไลน์',
  AccountsReceivable: 'ลูกหนี้:',
  PayableColon: 'เจ้าหนี้:',
  PrintByAccountNumber: 'พิมพ์ตามหมายเลขบิล',
  PrintAccordingAccountNumber: 'พิมพ์ตามหมายเลขใบแจ้งยอด',
  PrintByPaymentRequestNumber: 'พิมพ์ตามหมายเลขคำขอชำระเงิน',
  PushUFIDANeedReceiptDate: 'เพื่อส่งไปยังระบบใบสำคัญของ Yonyou ใบแจ้งหนี้เจ้าหนี้ต้องกรอกวันที่รับใบแจ้งหนี้จริง',
  WhenShareFinanceCost: '(เมื่อจัดสรรค่าใช้จ่ายทางการเงิน)',
  ReceivablesVerificationStatus: 'สถานะการตรวจสอบหนี้สิน',
  UnlockLedgerBatchNo: 'หมายเลขชุด',
  UnlockLedgerApplyUser: 'ผู้ยื่นคำขอ',
  UnlockLedgerStatus: 'สถานะ',
  UnlockLedgerOrderCount: 'จำนวนออเดอร์',
  UnlockLedgerDeclaredImpact: 'ผลกระทบกำไรที่แจ้ง',
  UnlockLedgerBeforeProfit: 'กำไรก่อนปลดล็อก',
  UnlockLedgerAfterProfit: 'กำไรหลังปลดล็อก',
  UnlockLedgerActualImpact: 'ผลกระทบกำไรจริง',
  UnlockLedgerRelockTime: 'เวลาล็อกใหม่อัตโนมัติ',
  UnlockLedgerApplyTime: 'เวลาส่ง',
  UnlockLedgerStatus0: 'รออนุมัติ',
  UnlockLedgerStatus1: 'กำลังปลดล็อก',
  UnlockLedgerStatus2: 'ล็อกใหม่แล้ว',
  UnlockLedgerStatus3: 'ถูกปฏิเสธ',
  UnlockLedgerManualRemarks: 'หมายเหตุล็อกด้วยตนเอง',
  UnlockLedgerStatus9: 'ผิดปกติ',
  UnlockLedgerDetailTitle: 'รายละเอียดคำขอปลดล็อก',
  UnlockLedgerApplyInfo: 'ข้อมูลคำขอ',
  UnlockLedgerSpNo: 'หมายเลขอนุมัติ WeCom',
  UnlockLedgerUnlockTime: 'เวลาปลดล็อกเสร็จ',
  UnlockLedgerPlanRelockTime: 'เวลาล็อกใหม่ตามแผน',
  UnlockLedgerActualRelockTime: 'เวลาล็อกใหม่จริง',
  UnlockLedgerFailReason: 'สาเหตุผิดปกติ',
  UnlockLedgerJobs: 'สแนปช็อตออเดอร์',
  UnlockLedgerJobNo: 'หมายเลขออเดอร์',
  UnlockLedgerCustomerName: 'ชื่อลูกค้า',
  UnlockLedgerBeforeReceivable: 'ลูกหนี้ก่อนปลดล็อก',
  UnlockLedgerBeforePayable: 'เจ้าหนี้ก่อนปลดล็อก',
  UnlockLedgerAfterReceivable: 'ลูกหนี้หลังล็อกใหม่',
  UnlockLedgerAfterPayable: 'เจ้าหนี้หลังล็อกใหม่',
  UnlockLedgerDiffTab: 'รายละเอียดผลต่างค่าธรรมเนียม',
  UnlockLedgerJobFilter: 'กรองตามออเดอร์',
  UnlockLedgerChargeName: 'ชื่อค่าธรรมเนียม',
  UnlockLedgerChangeType: 'ประเภทการเปลี่ยนแปลง',
  UnlockLedgerChangeType0: 'เพิ่ม',
  UnlockLedgerChangeType1: 'แก้ไข',
  UnlockLedgerChangeType2: 'ลบ',
  UnlockLedgerFieldChanges: 'ฟิลด์ที่เปลี่ยน',
  UnlockLedgerModifyUser: 'ผู้แก้ไข',
  UnlockLedgerModifyTime: 'เวลาแก้ไข',
  UnlockLedgerDiffEmptyTip: 'ไม่มีรายการผลต่าง (ผลต่างค่าธรรมเนียมจะสร้างเมื่อล็อกใหม่)',
  UnlockLedgerTip: 'การแก้ไขค่าธรรมเนียมของออเดอร์ที่ล็อกต้องขอปลดล็อกผ่านการอนุมัติ WeCom เมื่ออนุมัติแล้วจะปลดล็อกอัตโนมัติ และล็อกใหม่อัตโนมัติเวลา 01:00 หลัง 3 วัน โดยบันทึกความแตกต่างทั้งหมด'
}
